/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Quota_BodyInputs */

const en_why_listening_quota_body = /** @type {(inputs: Why_Listening_Quota_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many readers meter words, characters or hours. Listening is unlimited on the paid plan.`)
};

const es_why_listening_quota_body = /** @type {(inputs: Why_Listening_Quota_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muchos lectores limitan palabras, caracteres u horas. Listening es ilimitado en el plan de pago.`)
};

/**
* | output |
* | --- |
* | "Many readers meter words, characters or hours. Listening is unlimited on the paid plan." |
*
* @param {Why_Listening_Quota_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_quota_body = /** @type {((inputs?: Why_Listening_Quota_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Quota_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_quota_body(inputs)
	return en_why_listening_quota_body(inputs)
});